<template>
  <BannerCarousel
        apiEndpoint="/realtime-stats/"
        :transformData="transformStats"
        :refetchOnLanguageChange="true"
        height="50px"
        backgroundColor="#fff005"
        textColor="#000000"
        itemMinWidth="300px"
        position="top"
        :zIndex="99"
        :speed="50"
    >
        <template #item="{ item }">
            <div class="text-center">
                <div style="font-weight:bold">{{ item.value }}</div>
                <span>{{ item.label }}</span>
            </div>
        </template>
    </BannerCarousel>
    <div :class="paddingOrNoPadding">
        <v-container fluid>
            <v-row class="d-flex justify-space-between">
                <v-col class="text-h4 font-weight-bold">
                    {{ $t("landingPage.usefulLinks") }}</v-col
                >
                <v-col v-if="!$route.meta.hideBanners" class="text-right pb-0 pt-8">
                    <TextLink class="pl-0" :link="{ href: '/', text: $t('landingPage.back') }"/></v-col>
            </v-row>
            <v-row>
                <v-col
                    v-for="link in links"
                    :key="link.id"
                    cols="12"
                    sm="6"
                    md="3"
                    lg="3"
                >
                    <v-card
                        class="d-flex flex-column justify-space-between"
                        style="cursor: pointer"
                        @click="openLink(link.url)"
                        elevation="0"
                    >
                        <v-card-title class="text-h6 font-weight-bold">
                            {{ link.title }}
                        </v-card-title>
                        <v-card-text>
                            {{ link.description }}
                        </v-card-text>
                        <v-card-actions>
                            <v-icon>mdi-arrow-right</v-icon>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
    <BottomBanner v-if="!$route.meta.hideBanners" />
</template>

<script>
import axios from "axios";
import emitter from "@/eventBus";
import BannerCarousel from "@/components/BannerCarousel.vue";
import BottomBanner from "@/components/BottomBanner.vue";
import TextLink from "@/components/registration/TextLink.vue";

export default {
    name: "UsefulLinks",
    components: {
        BannerCarousel,
        BottomBanner,
        TextLink
    },
    data() {
        return {
            links: [],
        };
    },
    mounted() {
        this.fetchUsefulLinks();

        // Listen for language change events
        emitter.on("language-changed", this.fetchUsefulLinks);
    },
    unmounted() {
        // Clean up listener
        emitter.off("language-changed", this.fetchUsefulLinks);
    },
    computed: {
        paddingOrNoPadding() {
            return {
                "prices-container": !this.$route.meta.hideBanners,
                "no-padding": !!this.$route.meta.hideBanners,
            };
        },
    },
    methods: {
        /**
         * Fetches useful links data from the backend API.
         * Respects current language setting (backend reads Accept-Language header).
         */
        async fetchUsefulLinks() {
            try {
                const response = await axios.get("/useful-links/");
                this.links = response.data;
            } catch (error) {
                console.error("Failed to fetch useful links:", error);
            }
        },

        /**
         * Opens the provided URL in a new browser tab.
         * @param {string} url - The URL to open.
         */
        openLink(url) {
            window.open(url, "_blank");
        },
    },
};
</script>

<style scoped>
.prices-container {
    padding-top: 50px; /* height of StatsBanner */
    padding-bottom: 64px; /* height of BottomBanner */
}

.v-card {
    transition: transform 0.2s ease;
    min-height: 200px;
}

.v-card:hover {
    transform: translateY(-4px);
}

@media (max-width: 600px) {
    .prices-container {
        padding-top: 50px; /* height of StatsBanner */
        padding-bottom: 96px; /* height of BottomBanner */
    }
}
</style>